import React from 'react';

const AdminLogin = () => (
  <div className="admin-login">
    <h2>Admin Login</h2>
    <p>Placeholder admin login page. Implement form and call `/admin/login`.</p>
  </div>
);

export default AdminLogin;
